

const INITIAL_STATE = {
  
  name:'HAssan',
  current_stock:'fail',
  request:'fail',
  user:'fail'
 }





export default (state = INITIAL_STATE, action) => {

  if(action.type=='teachers')
  {    return({
    ...state,
    current_stock:action.payload,
    
  })
}
if(action.type=='request')
{    return({
  ...state,
  request:action.payload,
  
})
}
if(action.type=='users')
{    return({
  ...state,
  user:action.payload,
  
})
}
return state

}